import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SourcingLineItemPage } from '@/areas/sourcing-scenarios/SourcingScenarios/SourcingLineItemPage/SourcingLineItemPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ assemblyId: 'optional' }),
    component: RouteComponent,
    // Otherwise an open "Delete scenario" confirmation follows Back or Forward between a scenario and its copy.
    remountDeps: ({ params }) => params.sourcingScenarioId,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const assemblyId = Route.useSearch({ select: (search) => search.assemblyId });
    return <SourcingLineItemPage {...pathParams} assemblyId={assemblyId} />;
}
